var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlanderSafetyAirbags1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 529,
    height: 369,
    viewBox: "0 0 529 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M374.145 100.077C374.145 100.077 378.917 98.7334 383.877 98.7334C388.836 98.7334 440.517 96.1588 449.316 96.9424C458.116 97.7259 459.981 106.234 461.845 113.696C463.71 121.159 465.313 133.212 464.642 136.943C463.933 140.637 460.913 142.503 457.706 143.063C454.462 143.66 453.977 145.19 455.394 148.137C456.774 151.085 465.35 169.145 469.526 174.966C473.703 180.75 474.933 182.392 474.933 185.862C474.933 189.332 471.615 193.064 467.215 195.153C462.815 197.243 456.14 198.847 450.286 198.847C444.432 198.847 435.184 194.109 433.693 191.72C432.201 189.332 434.662 187.765 428.51 169.295C422.395 150.824 420.008 142.801 410.686 128.846C401.365 114.89 399.127 114.405 389.805 107.465C380.521 100.487 374.145 100.077 374.145 100.077Z",
    fill: "#686D71",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9313 191.758C80.3925 193.325 74.0163 192.952 64.6198 192.28C46.9082 190.974 46.1251 183.437 43.3285 176.571C40.532 169.705 31.9558 145.936 30.688 144.033C29.4202 142.093 28.3389 135.339 26.3254 131.383C24.3118 127.391 17.7119 100.562 17.7119 88.6213C17.7119 81.4197 20.3966 76.3822 24.722 76.4569C29.1592 76.5315 44.4845 76.9793 59.6978 77.6509C59.6978 77.6509 70.9587 76.7927 74.6502 88.1735C78.3417 99.5544 96.3143 174.854 97.8804 181.198C99.4465 187.541 93.1449 191.011 88.8941 191.795L88.9313 191.758Z",
    fill: "#686D71",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.499 100.077C217.499 100.077 214.367 94.9272 214.367 86.3076C214.367 77.688 220.37 69.4043 224.659 69.4043H253.295C258.441 69.4043 274.214 76.3074 274.139 88.0614C274.102 97.5392 271.343 100.077 271.343 100.077",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250.723 253.624C250.723 253.624 255.868 250.191 265.041 248.176C274.214 246.161 320.861 233.848 320.861 233.848C327.461 235.004 332.867 232.43 335.179 232.131C337.454 231.833 341.481 229.556 343.755 221.011C346.03 212.467 346.627 204.929 334.583 175.712C322.576 146.495 309.973 125.301 303.075 116.42C296.214 107.539 284.468 100.076 275.295 100.076H232.638C222.906 100.076 210.862 100.487 201.13 102.576C191.398 104.666 186.812 105.748 181.069 111.382C175.327 116.98 178.944 120.412 181.069 127.577C183.195 134.741 192.815 171.421 198.445 185.75C204.113 200.078 206.835 212.355 210.825 224.967C214.852 237.579 215.971 240.154 215.672 241.87C215.374 243.587 214.815 244.743 215.971 249.333C217.127 253.923 229.431 285.714 233.421 291.722C237.448 297.729 241.811 295.229 254.675 298.438C267.502 301.647 322.464 306.05 327.647 306.05C332.83 306.05 331.935 302.916 331.078 298.028C330.22 293.14 325.634 274.819 317.057 270.826C308.481 266.796 295.02 266.535 279.546 264.818C264.072 263.102 258.367 260.788 250.648 253.624H250.723Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.672 240.154L236.553 242.132",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.614 143.062L195.76 139.032",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M234.986 75.1504C234.986 75.1504 239.834 86.6058 234.986 96.9419",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M313.888 133.025C311.986 133.921 302.254 142.802 303.708 165.713",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M288.233 144.891C288.233 144.891 293.938 150.003 305.237 147.391",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M258.217 270.267C258.217 270.267 289.016 274.856 302.515 276.274C316.013 277.729 318.623 285.603 318.623 289.371V293.14C318.623 294.819 316.46 296.275 312.843 296.013C309.226 295.752 263.959 290.454 263.959 290.454",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M355.687 250.005V273.364C355.687 284.185 353.748 294.558 353.748 294.558",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M271.454 231.236V245.453",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M277.719 173.175C277.719 173.175 298.674 169.817 302.515 169.331C306.356 168.846 308.779 174.406 310.942 178.473C313.105 182.578 318.176 194.145 318.176 197.728V201.347C318.176 203.287 322.874 212.914 323.769 218.81C324.664 224.706 323.135 230.751 320.898 233.885",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M313.888 240.154C313.888 240.154 323.471 238.363 333.799 238.363C344.128 238.363 347.745 238.624 353.785 239.258C359.826 239.93 370.64 241.161 380.26 241.161C389.88 241.161 402.893 240.415 417.808 235.826C432.723 231.236 439.473 226.684 439.473 226.684",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M278.912 210.042L315.044 203.102",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M327.982 100.45C339.542 99.6663 353.636 98.7334 360.758 98.7334C372.541 98.7334 382.422 100.413 397.114 113.174C411.805 125.935 421.425 146.421 425.266 158.697C429.107 170.974 433.432 184.966 433.693 191.72C433.954 198.474 428.398 206.161 422.618 208.362C416.839 210.527 412.737 210.042 412.737 210.042",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M296.735 109.741C296.735 109.741 304.454 101.383 311.166 101.383C313.85 101.383 320.376 100.973 327.982 100.45",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M337.603 231.236C337.603 231.236 346.813 228.811 354.755 226.646C362.697 224.482 402.408 212.989 409.158 211.46C415.907 209.93 416.876 204.706 416.876 198.213C416.876 191.72 416.168 185.19 411.805 175.825C407.48 166.421 402.893 156.384 401.215 149.369C399.537 142.354 400.022 135.115 400.022 130.562C400.022 126.01 401.476 123.809 401.476 123.809",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M324.029 102.577C324.029 102.577 341.517 119.704 346.588 130.04C351.622 140.376 367.768 175.079 372.839 190.751C377.91 206.423 375.747 213.624 372.839 218.811",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.121 100.935C332.121 100.935 346.067 112.203 349.907 117.054C353.785 121.868 355.202 126.457 355.202 126.457",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M357.887 133.025C357.887 133.025 372.578 158.362 379.551 181.198C386.524 204.034 384.137 215.303 379.551 219.669",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M360.758 131.271C360.758 131.271 371.795 128.846 377.239 128.846C382.683 128.846 389.954 131.495 393.757 131.98C397.598 132.465 399.052 131.98 399.052 131.98",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M369.931 100.935C369.931 100.935 376.419 108.136 379.924 115.823C383.429 123.547 381.266 128.846 381.266 128.846",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M369.931 156.533C369.931 156.533 388.09 153.361 394.951 152.465C401.812 151.57 402.073 152.465 402.073 152.465",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M381.527 188.324L414.005 181.16",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M383.914 218.81C383.914 218.81 405.988 216.721 420.083 216.721H434.177C440.665 216.721 444.469 221.87 444.469 228.363V242.094C444.469 249.221 441.486 263.513 437.16 267.356C432.835 271.199 424.967 274.707 419.822 276.871C414.676 279.035 362.585 300.715 355.724 303.178C348.863 305.603 332.121 304.521 332.121 304.521",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M429.442 203.101L444.469 198.848",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M470.458 194.22C470.458 194.22 484.516 191.795 492.383 191.795H510.244C518.373 191.795 523.519 192.877 525.681 198.847C527.844 204.818 528.664 213.064 527.583 218.848C526.502 224.631 521.915 232.206 514.868 235.453C507.821 238.699 490.78 246.833 476.424 248.736C462.069 250.639 450.435 249.781 444.059 247.617",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M431.194 206.571C432.015 207.28 452.299 206.982 461.248 208.363C470.197 209.706 474.262 210.788 482.912 210.116C491.563 209.445 507.298 204.855 518.671 198.885",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M476.946 215.639V241.124",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M440.367 100.935C440.367 100.935 447.154 103.435 449.316 109.144C451.479 114.815 452.56 120.748 453.381 130.525C454.201 140.301 452.038 143.062 452.038 143.062",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7379 73.9939C65.7379 73.9939 66.5955 67.5759 47.8398 63.4713C47.8398 63.4713 66.9311 42.5381 68.8701 42.6873C70.7718 42.8366 71.8158 50.9338 70.5853 56.7921C69.3548 62.6131 65.7379 73.9939 65.7379 73.9939ZM65.7379 73.9939C65.7379 73.9939 107.612 76.2701 111.266 74.8521C114.92 73.4342 116.785 75.0387 118.015 65.5236C119.246 56.0085 114.436 47.0531 105.114 45.6351C95.7918 44.1799 68.8328 42.6873 68.8328 42.6873",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.88 67.6883C124.429 62.8748 129.985 57.2777 130.88 57.3523C132.371 57.4642 132.334 66.9047 131.476 71.6436",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 83.77C153.924 84.1058 164.103 84.3297 165.669 83.77C168.652 82.6133 170.181 83.9193 171.225 76.1206C172.232 68.3219 168.279 60.971 160.635 59.777C152.991 58.5829 130.88 57.3516 130.88 57.3516",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M164.066 60.3C167.049 56.7925 170.517 52.7999 171.076 52.8372C172.046 52.9118 172.382 57.8 171.599 61.3448C171.3 62.6881 170.815 64.4792 170.331 66.1957",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M171.784 71.9418C177.825 72.203 190.652 72.6508 192.106 71.9791C194.008 71.0836 194.94 72.0537 195.835 66.27C196.73 60.5236 194.493 55.1131 189.72 54.3295C184.947 53.5459 171.113 52.8369 171.113 52.8369",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M117.531 68.8076C117.531 68.8076 128.307 70.1882 138.412 77.054C148.48 83.9199 144.155 96.8679 145.795 107.055C147.473 117.241 151.687 167.093 151.836 172.616",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1309 192.69C91.1309 192.69 124.242 184.294 129.947 181.869C135.652 179.444 123.012 140.226 122.005 136.98C120.961 133.734 121.334 111.047 120.886 106.121C120.439 101.196 117.941 83.5461 116.971 78.0983L116.039 72.6504",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8408 63.4717L37.4375 64.0314",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8984 68.5088C23.1933 70.3372 28.1525 72.9119 32.6643 75.7851",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8536 75.6354C42.2469 68.5457 34.3419 62.3516 34.3419 62.3516C34.3419 62.3516 32.9996 60.1127 18.3828 64.777",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.501 60.8966C19.501 60.8966 39.1143 56.4562 34.3415 62.3892",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3516 184.258C61.3006 207.579 73.0462 237.356 74.053 240.043",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1549 191.721C94.8599 208.848 99.7445 225.975 97.7683 228.662C94.0022 233.774 79.7584 244.483 75.2466 244.707C70.7348 244.893 65.1416 240.229 65.1416 240.229",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8838 111.793C89.8633 111.047 119.917 109.479 119.917 109.479",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8633 145.264C102.989 143.846 123.422 141.645 123.422 141.645",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M151.016 161.085C151.016 161.085 172.419 156.271 174.171 154.107C175.924 151.98 173.687 97.0912 170.965 90.0388C168.243 82.9491 165.67 83.7327 165.67 83.7327",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M194.642 70.5986C194.642 70.5986 194.418 76.8301 195.35 84.4795C195.686 87.39 196.767 93.9946 197.923 101.532",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M189.309 160.228C180.621 163.325 170.181 167.019 170.181 167.019",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M179.279 99.0689C185.544 98.845 197.438 98.4346 197.438 98.4346",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M171.188 76.084C171.188 76.084 179.055 96.9053 179.987 108.547C180.92 120.189 181.031 135.414 181.031 135.414",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M174.618 133.249C174.618 133.249 182.449 135.451 183.381 138.436C184.313 141.421 175.513 137.801 175.513 137.801",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M179.95 139.294L178.049 162.615",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M194.604 73.6953C194.604 73.6953 207.581 75.1879 209.52 77.9491C210.116 78.8074 212.13 82.2776 214.591 87.1657",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3203 219.855C97.3203 219.855 157.801 236.124 174.394 239.184C199.339 243.774 175.997 268.7 175.997 268.7",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M153.364 278.326C156.907 278.849 160.188 279.297 163.059 279.52C175.028 280.491 198.37 264.035 215.56 249.109",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M201.428 197.616C175.737 193.959 144.676 189.481 139.754 187.988C131.663 185.526 129.91 181.869 129.91 181.869C129.91 181.869 164.476 169.145 170.144 167.018C175.774 164.891 171.896 157.391 171.113 155.04",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9785 203.25L137.964 187.392",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M179.279 194.93C179.241 194.444 122.639 225.229 122.639 225.229",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M203.702 205.452C188.936 215.228 158.547 235.415 158.547 235.415",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M139.754 187.989L145.608 182.653L154.781 186.31L152.208 190.825L96.5752 216.609",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M145.608 182.653L149.747 179.929L160.822 182.354L154.781 186.309",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M140.276 179.183L149.747 179.929",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M160.821 182.354C160.821 182.354 179.391 184.556 198.817 188.511",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M177.526 164.406C177.526 164.406 183.082 165.376 191.36 166.794",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M191.585 165.525C189.571 165.787 187.371 166.122 187.371 166.122",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M212.614 231.311C204.448 239.109 196.171 246.385 191.957 248.214",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5273 241.722C89.5273 241.722 102.839 253.364 132.445 256.423C162.015 259.483 179.316 254.595 179.316 254.595",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M201.167 75.8594C201.167 75.8594 203.852 86.3447 205.977 100.524",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M279.993 130.899L224.509 184.743C224.919 186.124 225.404 187.616 225.888 189.183L280.701 135.973C280.515 134.294 280.291 132.578 279.993 130.861",
    fill: "#686D71"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M279.993 130.899L224.509 184.743C224.919 186.124 225.404 187.616 225.888 189.183L280.701 135.973C280.515 134.294 280.291 132.578 279.993 130.861V130.899Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M269.776 111.831L216.082 163.959C216.679 165.862 217.163 167.392 217.536 168.362L273.281 114.256C272.237 113.212 271.081 112.391 269.814 111.831",
    fill: "#686D71"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M269.776 111.831L216.082 163.959C216.679 165.862 217.163 167.392 217.536 168.362L273.281 114.256C272.237 113.212 271.081 112.391 269.814 111.831H269.776Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M268.397 111.383C267.54 111.197 266.346 111.01 264.892 110.786L214.74 159.481C215.225 161.123 215.71 162.616 216.12 163.959L269.814 111.831C269.367 111.644 268.919 111.458 268.434 111.383",
    fill: "#686D71"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M268.397 111.383C267.54 111.197 266.346 111.01 264.892 110.786L214.74 159.481C215.225 161.123 215.71 162.616 216.12 163.959L269.814 111.831C269.367 111.644 268.919 111.458 268.434 111.383H268.397Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M278.986 126.085L223.092 180.34C223.502 181.534 223.987 183.026 224.509 184.743L279.993 130.898C279.694 129.257 279.396 127.652 278.986 126.085Z",
    fill: "#686D71"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M278.986 126.085L223.092 180.34C223.502 181.534 223.987 183.026 224.509 184.743L279.993 130.898C279.694 129.257 279.396 127.652 278.986 126.085Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M275.743 117.651L219.289 172.429C220.072 174.033 220.706 175.19 221.303 176.272L277.57 121.644C277.048 120.226 276.414 118.883 275.743 117.651Z",
    fill: "#686D71"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M275.743 117.651L219.289 172.429C220.072 174.033 220.706 175.19 221.303 176.272L277.57 121.644C277.048 120.226 276.414 118.883 275.743 117.651Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M259.521 110.226L213.359 155.003C213.844 156.57 214.292 158.1 214.702 159.481L264.891 110.786C263.362 110.599 261.535 110.375 259.521 110.188",
    fill: "#686D71"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M259.521 110.226L213.359 155.003C213.844 156.57 214.292 158.1 214.702 159.481L264.891 110.786C263.362 110.599 261.535 110.375 259.521 110.188V110.226Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M277.607 121.645L221.34 176.235C221.564 176.646 221.825 177.056 222.048 177.504C222.235 177.877 222.608 178.885 223.092 180.34L278.987 126.085C278.576 124.555 278.129 123.025 277.607 121.645Z",
    fill: "#686D71"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M277.607 121.645L221.34 176.235C221.564 176.646 221.825 177.056 222.048 177.504C222.235 177.877 222.608 178.885 223.092 180.34L278.987 126.085C278.576 124.555 278.129 123.025 277.607 121.645Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M273.244 114.256L217.499 168.361C217.648 168.735 217.76 169.07 217.835 169.294C218.357 170.526 218.841 171.533 219.289 172.429L275.742 117.651C274.997 116.383 274.176 115.226 273.244 114.256Z",
    fill: "#686D71"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M273.244 114.256L217.499 168.361C217.648 168.735 217.76 169.07 217.835 169.294C218.357 170.526 218.841 171.533 219.289 172.429L275.742 117.651C274.997 116.383 274.176 115.226 273.244 114.256Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M208.513 107.539L201.727 114.144C201.838 114.666 201.95 115.188 202.137 115.823C202.323 116.532 202.584 117.502 202.957 118.771L214.33 107.726C212.055 107.651 210.116 107.576 208.55 107.539",
    fill: "#686D71"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M208.513 107.539L201.727 114.144C201.838 114.666 201.95 115.188 202.137 115.823C202.323 116.532 202.584 117.502 202.957 118.771L214.33 107.726C212.055 107.651 210.116 107.576 208.55 107.539H208.513Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M254.003 109.741L212.018 150.488C212.465 152.056 212.912 153.548 213.36 155.003L259.522 110.226C257.807 110.077 255.98 109.928 254.003 109.779",
    fill: "#686D71"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M254.003 109.741L212.018 150.488C212.465 152.056 212.912 153.548 213.36 155.003L259.522 110.226C257.807 110.077 255.98 109.928 254.003 109.779V109.741Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M205.828 107.465C202.211 107.39 200.458 108.286 201.726 114.144L208.512 107.54C207.394 107.54 206.461 107.502 205.828 107.465Z",
    fill: "#686D71"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M205.828 107.465C202.211 107.39 200.458 108.286 201.726 114.144L208.512 107.54C207.394 107.54 206.461 107.502 205.828 107.465Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M220.035 107.95L204.188 123.324C204.598 124.742 205.008 126.271 205.493 127.876L225.777 108.174C223.801 108.099 221.862 108.025 220.035 107.95Z",
    fill: "#686D71"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M220.035 107.95L204.188 123.324C204.598 124.742 205.008 126.271 205.493 127.876L225.777 108.174C223.801 108.099 221.862 108.025 220.035 107.95Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M214.293 107.726L202.92 118.771C203.293 120.039 203.703 121.606 204.188 123.323L220.035 107.949C217.947 107.875 216.045 107.8 214.293 107.726Z",
    fill: "#686D71"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M214.293 107.726L202.92 118.771C203.293 120.039 203.703 121.606 204.188 123.323L220.035 107.949C217.947 107.875 216.045 107.8 214.293 107.726Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M242.817 109.032L209.407 141.458C209.855 142.988 210.265 144.481 210.712 145.973L248.447 109.368C246.62 109.256 244.756 109.144 242.817 109.032Z",
    fill: "#686D71"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M242.817 109.032L209.407 141.458C209.855 142.988 210.265 144.481 210.712 145.973L248.447 109.368C246.62 109.256 244.756 109.144 242.817 109.032Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M231.481 108.435L206.797 132.39C207.207 133.883 207.654 135.375 208.102 136.943L237.186 108.733C235.285 108.621 233.383 108.547 231.519 108.435",
    fill: "#686D71"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M231.481 108.435L206.797 132.39C207.207 133.883 207.654 135.375 208.102 136.943L237.186 108.733C235.285 108.621 233.383 108.547 231.519 108.435H231.481Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M248.448 109.368L210.713 145.973C211.16 147.503 211.608 149.033 212.018 150.488L254.004 109.741C252.214 109.592 250.35 109.48 248.448 109.368Z",
    fill: "#686D71"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M248.448 109.368L210.713 145.973C211.16 147.503 211.608 149.033 212.018 150.488L254.004 109.741C252.214 109.592 250.35 109.48 248.448 109.368Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M237.15 108.696L208.065 136.906C208.513 138.398 208.923 139.928 209.371 141.421L242.78 108.995C240.916 108.883 239.014 108.771 237.113 108.696",
    fill: "#686D71"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M237.15 108.696L208.065 136.906C208.513 138.398 208.923 139.928 209.371 141.421L242.78 108.995C240.916 108.883 239.014 108.771 237.113 108.696H237.15Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M225.777 108.174L205.492 127.876C205.902 129.331 206.35 130.824 206.797 132.428L231.482 108.472C229.543 108.398 227.641 108.286 225.777 108.211",
    fill: "white",
    fillOpacity: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M225.777 108.174L205.492 127.876C205.902 129.331 206.35 130.824 206.797 132.428L231.482 108.472C229.543 108.398 227.641 108.286 225.777 108.211V108.174Z",
    fill: "#686D71",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M270.709 197.877L239.499 228.176C240.431 229.184 241.55 230.042 242.892 230.676L272.983 201.459C272.238 200.265 271.455 199.071 270.709 197.877Z",
    fill: "#686D71"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M270.709 197.877L239.499 228.176C240.431 229.184 241.55 230.042 242.892 230.676L272.983 201.459C272.238 200.265 271.455 199.071 270.709 197.877Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M275.295 205.041L247.366 232.168C249.193 232.654 250.797 232.952 252.363 233.139L277.681 208.586C276.935 207.504 276.152 206.347 275.295 205.078",
    fill: "#686D71"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M275.295 205.041L247.366 232.168C249.193 232.654 250.797 232.952 252.363 233.139L277.681 208.586C276.935 207.504 276.152 206.347 275.295 205.078V205.041Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M281.112 141.047C281 139.443 280.888 137.764 280.702 136.01L225.889 189.22C226.336 190.675 226.784 192.168 227.268 193.697L281.149 141.42C281.149 141.42 281.149 141.196 281.149 141.084",
    fill: "#686D71"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M281.112 141.047C281 139.443 280.888 137.764 280.702 136.01L225.889 189.22C226.336 190.675 226.784 192.168 227.268 193.697L281.149 141.42C281.149 141.42 281.149 141.196 281.149 141.084L281.112 141.047Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M268.471 194.295L237.149 224.706C237.821 226.012 238.566 227.169 239.536 228.176L270.746 197.877C270 196.683 269.217 195.452 268.508 194.258",
    fill: "white",
    fillOpacity: 0.5
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M268.471 194.295L237.149 224.706C237.821 226.012 238.566 227.169 239.536 228.176L270.746 197.877C270 196.683 269.217 195.452 268.508 194.258L268.471 194.295Z",
    fill: "#686D71",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M272.983 201.459L242.892 230.676C243.302 230.863 243.749 231.086 244.234 231.236C245.353 231.609 246.359 231.907 247.329 232.169L275.257 205.041C274.512 203.922 273.728 202.728 272.945 201.496",
    fill: "#686D71"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M272.983 201.459L242.892 230.676C243.302 230.863 243.749 231.086 244.234 231.236C245.353 231.609 246.359 231.907 247.329 232.169L275.257 205.041C274.512 203.922 273.728 202.728 272.945 201.496L272.983 201.459Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M273.542 229.93C277.084 228.587 279.844 226.87 281.261 224.594C282.044 223.326 282.64 222.057 283.013 220.751L273.542 229.93Z",
    fill: "#686D71"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M273.542 229.93C277.084 228.587 279.844 226.87 281.261 224.594C282.044 223.326 282.64 222.057 283.013 220.751L273.542 229.93Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M277.682 208.549L252.363 233.102C254.377 233.326 256.278 233.288 258.329 233.102L280.18 211.907C279.509 211.049 278.651 209.892 277.719 208.512",
    fill: "white",
    fillOpacity: 0.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M277.682 208.549L252.363 233.102C254.377 233.326 256.278 233.288 258.329 233.102L280.18 211.907C279.509 211.049 278.651 209.892 277.719 208.512L277.682 208.549Z",
    fill: "#686D71",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M282.752 215.191L265.339 232.095C268.396 231.535 271.156 230.826 273.542 229.931L283.013 220.751C283.573 218.811 283.573 216.908 282.752 215.229",
    fill: "#686D71"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M282.752 215.191L265.339 232.095C268.396 231.535 271.156 230.826 273.542 229.931L283.013 220.751C283.573 218.811 283.573 216.908 282.752 215.229V215.191Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M281.261 213.213C280.963 212.952 280.59 212.467 280.142 211.907L258.329 233.102C260.268 232.915 262.319 232.617 264.705 232.206C264.929 232.169 265.153 232.132 265.376 232.057L282.79 215.154C282.454 214.445 281.969 213.773 281.298 213.176",
    fill: "#686D71"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M281.261 213.213C280.963 212.952 280.59 212.467 280.142 211.907L258.329 233.102C260.268 232.915 262.319 232.617 264.705 232.206C264.929 232.169 265.153 232.132 265.376 232.057L282.79 215.154C282.454 214.445 281.969 213.773 281.298 213.176L281.261 213.213Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M266.196 190.676L235.434 220.527C235.918 221.982 236.44 223.4 237.112 224.706L268.433 194.295C267.65 193.064 266.904 191.833 266.196 190.676Z",
    fill: "#686D71"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M266.196 190.676L235.434 220.527C235.918 221.982 236.44 223.4 237.112 224.706L268.433 194.295C267.65 193.064 266.904 191.833 266.196 190.676Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M262.207 177.168C263.214 176.869 264.482 176.608 266.085 176.31C267.39 176.086 268.62 175.862 269.739 175.638L278.912 166.72C279.434 164.742 279.919 162.279 280.292 159.593L262.207 177.168Z",
    fill: "#686D71"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M262.207 177.168C263.214 176.869 264.482 176.608 266.085 176.31C267.39 176.086 268.62 175.862 269.739 175.638L278.912 166.72C279.434 164.742 279.919 162.279 280.292 159.593L262.207 177.168Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M269.739 175.638C273.319 174.892 276.078 173.809 277.719 170.302C278.129 169.406 278.539 168.175 278.912 166.72L269.739 175.638Z",
    fill: "#686D71"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M269.739 175.638C273.319 174.892 276.078 173.809 277.719 170.302C278.129 169.406 278.539 168.175 278.912 166.72L269.739 175.638Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M228.611 198.139C229.059 199.668 229.544 201.161 229.991 202.616L281 153.138C281.15 151.16 281.224 149.145 281.261 147.093L228.649 198.176",
    fill: "#686D71"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M228.611 198.139C229.059 199.668 229.544 201.161 229.991 202.616L281 153.138C281.15 151.16 281.224 149.145 281.261 147.093L228.649 198.176L228.611 198.139Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M281.148 141.384L227.268 193.661C227.715 195.154 228.162 196.646 228.647 198.139L281.26 147.056C281.26 145.153 281.26 143.249 281.148 141.384Z",
    fill: "#686D71"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M281.148 141.384L227.268 193.661C227.715 195.154 228.162 196.646 228.647 198.139L281.26 147.056C281.26 145.153 281.26 143.249 281.148 141.384Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M260.492 181.16C260.082 180.451 259.895 179.891 259.858 179.406L231.37 207.093C231.855 208.698 232.34 210.079 232.675 211.123C232.712 211.235 232.75 211.347 232.787 211.496L261.76 183.362C261.163 182.317 260.716 181.57 260.492 181.16Z",
    fill: "#686D71"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M260.492 181.16C260.082 180.451 259.895 179.891 259.858 179.406L231.37 207.093C231.855 208.698 232.34 210.079 232.675 211.123C232.712 211.235 232.75 211.347 232.787 211.496L261.76 183.362C261.163 182.317 260.716 181.57 260.492 181.16Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M229.99 202.616C230.475 204.221 230.96 205.713 231.37 207.057L259.895 179.407C259.783 178.287 260.604 177.653 262.207 177.168L280.291 159.593C280.59 157.578 280.813 155.377 280.963 153.138L229.953 202.654",
    fill: "#686D71"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M229.99 202.616C230.475 204.221 230.96 205.713 231.37 207.057L259.895 179.407C259.783 178.287 260.604 177.653 262.207 177.168L280.291 159.593C280.59 157.578 280.813 155.377 280.963 153.138L229.953 202.654L229.99 202.616Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M261.797 183.362L232.824 211.497C233.309 212.952 233.719 214.445 234.129 216.012L263.997 187.019C263.139 185.601 262.393 184.37 261.797 183.362Z",
    fill: "#686D71"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M261.797 183.362L232.824 211.497C233.309 212.952 233.719 214.445 234.129 216.012L263.997 187.019C263.139 185.601 262.393 184.37 261.797 183.362Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M263.996 187.019L234.129 216.012C234.539 217.504 234.949 219.034 235.434 220.527L266.196 190.675C265.413 189.369 264.668 188.138 263.959 187.019",
    fill: "#686D71"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M263.996 187.019L234.129 216.012C234.539 217.504 234.949 219.034 235.434 220.527L266.196 190.675C265.413 189.369 264.668 188.138 263.959 187.019H263.996Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M442.455 96.793L410.201 128.1C410.388 128.361 410.537 128.585 410.686 128.846C411.32 129.816 411.916 130.749 412.513 131.644L448.346 96.8676C446.93 96.793 444.916 96.7556 442.455 96.793Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M436.377 96.8676L407.777 124.629C408.523 125.674 409.306 126.831 410.164 128.1L442.418 96.793C440.628 96.793 438.577 96.8303 436.34 96.8676H436.377Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M430.262 97.0166L405.316 121.234C406.099 122.241 406.92 123.36 407.815 124.592L436.414 96.8301C434.475 96.8674 432.425 96.942 430.299 96.9793L430.262 97.0166Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M460.465 108.286L420.642 146.944C421.201 148.287 421.76 149.705 422.32 151.123L461.695 112.913C461.322 111.383 460.912 109.816 460.465 108.323V108.286Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M449.354 96.9418C449.056 96.9418 448.72 96.9045 448.347 96.8672L412.514 131.644C413.334 132.913 414.042 134.107 414.751 135.301L453.195 97.9866C452.076 97.4642 450.808 97.0911 449.354 96.9791V96.9418Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M456.55 100.487L416.839 139.033C417.547 140.339 418.181 141.608 418.815 142.914L458.862 104.069C458.228 102.763 457.482 101.532 456.587 100.487H456.55Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M458.862 104.032L418.815 142.877C419.449 144.22 420.046 145.563 420.643 146.906L460.466 108.249C460.018 106.756 459.496 105.338 458.862 103.995V104.032Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M453.195 97.9494L414.751 135.264C415.497 136.532 416.205 137.801 416.876 138.995L456.588 100.449C455.656 99.4047 454.574 98.5465 453.232 97.9121L453.195 97.9494Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M424.11 97.2032L402.67 118.024C403.49 118.957 404.385 120.039 405.317 121.234L430.263 97.0166C428.249 97.0539 426.198 97.1285 424.073 97.2032H424.11Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M411.693 97.6887L396.517 112.428C397.673 113.286 398.717 114.144 399.761 115.077L417.92 97.4648C415.832 97.5395 413.781 97.6141 411.693 97.6887Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M383.914 98.7338C382.758 98.7338 381.602 98.8084 380.52 98.9204L378.283 101.085C379.439 101.495 380.856 102.092 382.422 102.876L386.785 98.6592C385.442 98.6965 384.436 98.7338 383.914 98.7338Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M374.145 100.077C374.145 100.077 375.673 100.189 378.283 101.084L380.521 98.9199C376.978 99.2931 374.145 100.077 374.145 100.077Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M386.785 98.6585L382.422 102.875C383.615 103.472 384.846 104.144 386.225 105.002L393.012 98.4346C390.513 98.5465 388.388 98.6211 386.785 98.6585Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M405.466 97.9126L393.124 109.89C394.392 110.786 395.473 111.607 396.517 112.39L411.693 97.6514C409.568 97.726 407.48 97.8006 405.466 97.9126Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M392.975 98.435L386.188 105.002C387.307 105.711 388.463 106.495 389.694 107.39L399.202 98.1738C396.965 98.2485 394.839 98.3604 392.975 98.435Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M399.239 98.1733L389.73 107.39C389.73 107.39 389.805 107.427 389.842 107.465C391.036 108.36 392.117 109.144 393.124 109.89L405.466 97.9121C403.303 97.9867 401.215 98.0987 399.239 98.1733Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M417.883 97.4272L399.724 115.04C400.693 115.935 401.625 116.868 402.632 117.987L424.072 97.166C422.022 97.2406 419.971 97.3153 417.883 97.3899V97.4272Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M465.126 167.541L437.272 194.556C438.428 195.228 439.771 195.9 441.225 196.534L467.214 171.31C466.543 170.153 465.835 168.884 465.126 167.541Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M469.526 174.966C469.526 174.966 469.526 174.966 469.526 174.929L445.625 198.138C447.266 198.586 448.906 198.884 450.323 198.884C450.51 198.884 450.659 198.884 450.845 198.884L471.95 178.399C471.279 177.429 470.496 176.347 469.526 175.003V174.966Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M461.1 159.854L432.91 187.205C433.134 189.668 433.022 190.638 433.693 191.72C433.768 191.832 433.842 191.906 433.917 192.018L463.076 163.734C462.405 162.428 461.734 161.16 461.1 159.854Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M463.075 163.735L433.916 192.019C434.513 192.765 435.706 193.661 437.272 194.556L465.126 167.541C464.455 166.309 463.783 165.003 463.075 163.697V163.735Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M467.214 171.31L441.225 196.534C442.642 197.131 444.133 197.691 445.587 198.101L469.489 174.892C468.817 173.959 468.034 172.728 467.214 171.31Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M474.746 187.168C474.858 186.72 474.896 186.272 474.896 185.862C474.896 184.407 474.672 183.25 474.113 182.019L457.52 198.138C460.614 197.579 463.597 196.683 466.058 195.638L474.784 187.168H474.746Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M467.215 195.116C471.055 193.287 474.075 190.228 474.784 187.168L466.059 195.638C466.431 195.489 466.842 195.302 467.215 195.153V195.116Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M471.912 178.324L450.808 198.81C453.008 198.81 455.282 198.511 457.519 198.101L474.112 181.981C473.628 180.936 472.956 179.779 471.912 178.324Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M457.221 152.018L431.008 177.466C431.493 179.257 431.865 180.824 432.126 182.167L459.123 155.936C458.414 154.48 457.78 153.174 457.221 152.018Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M464.343 127.727L426.832 164.145C427.279 165.563 427.764 166.981 428.286 168.548L464.791 133.137C464.716 131.57 464.567 129.742 464.343 127.764V127.727Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M463.635 122.614L425.378 159.742C425.825 161.123 426.347 162.578 426.832 164.108L464.344 127.689C464.157 126.047 463.933 124.331 463.635 122.577V122.614Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M459.16 155.936L432.164 182.167C432.612 184.369 432.835 185.973 432.947 187.205L461.137 159.854C460.465 158.51 459.794 157.204 459.198 155.936H459.16Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M462.74 117.651L423.849 155.376C424.333 156.757 424.855 158.212 425.34 159.742L463.597 122.614C463.336 120.935 463.038 119.256 462.702 117.689L462.74 117.651Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M461.883 113.697C461.808 113.435 461.771 113.174 461.696 112.913L422.32 151.123C422.842 152.503 423.364 153.921 423.886 155.414L462.777 117.689C462.479 116.271 462.181 114.928 461.883 113.697Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M455.394 148.137C455.394 148.137 455.394 148.1 455.357 148.062L429.703 172.951C430.225 174.63 430.635 176.123 431.008 177.466L457.221 152.018C456.327 150.189 455.655 148.771 455.357 148.137H455.394Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M457.706 143.063C460.95 142.466 463.971 140.637 464.642 136.906C464.791 136.048 464.828 134.704 464.754 133.062L428.249 168.511C428.324 168.772 428.398 168.996 428.51 169.295C428.957 170.601 429.33 171.795 429.666 172.951L455.32 148.063C453.978 145.19 454.462 143.66 457.669 143.063H457.706Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3817 86.8301L26.8467 132.018C27.406 133.361 27.8907 134.853 28.3382 136.383M28.3382 136.383L75.1342 90.9719M28.3382 136.383C28.8229 138.025 29.2331 139.592 29.6433 140.898L76.4766 95.4497",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1483 100.562L31.4336 144.928C31.881 145.936 32.4404 147.391 33.1115 149.107L78.1923 105.338",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1312 109.256L34.7148 153.324C35.2369 154.705 35.7589 156.122 36.3182 157.578L81.0634 114.144",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4769 95.4121L29.6436 140.861C29.9791 141.943 30.3147 142.801 30.6503 143.324C30.7995 143.547 31.0605 144.107 31.4334 144.928L77.9311 99.7779",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9379 104.629L33.1113 149.145C33.5961 150.413 34.1554 151.831 34.7147 153.361L80.1311 109.293",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M68.311 80.1885L23.9014 123.286C24.3861 125.04 24.7963 126.57 25.2064 127.801L71.5 82.5",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7559 81.8674L24.3117 76.4941C21.7762 76.6807 19.8372 78.6584 18.7559 81.8674Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2029 76.5684L17.7861 88.6208C17.7861 90.2254 17.898 92.0537 18.1217 94.0687L35.9825 76.7176C33.8198 76.643 31.8809 76.6057 30.2029 76.5684Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7216 76.4199C24.7216 76.4199 24.4233 76.4572 24.3115 76.4946L18.7556 81.8678C18.1217 83.7335 17.7861 85.935 17.7861 88.4724C17.7861 88.4724 17.7861 88.547 17.7861 88.5843L30.2029 76.5319C27.7792 76.4572 25.8776 76.4199 24.7216 76.4199Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6871 78.8818L22.708 118.659C23.1182 120.338 23.5283 121.868 23.9012 123.286L68.3108 80.1878",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1007 114.145L36.3555 157.578C36.8775 158.996 37.4368 160.414 37.9588 161.832L81.66 119.406",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M36.02 76.7178L18.1592 94.0689C18.3083 95.7107 18.5321 97.4272 18.8304 99.2182L41.7996 76.9043C39.7487 76.8297 37.8098 76.7924 36.02 76.7178Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2845 77.3525L20.5459 109.107C20.8815 110.749 21.2171 112.316 21.59 113.92L58.9895 77.6137C57.0878 77.5391 55.1488 77.4645 53.2845 77.3525Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0265 77.5762L21.627 113.883C21.9998 115.525 22.3727 117.092 22.7456 118.622L64.5 78C62.5983 77.9254 60.9654 77.6508 59.0638 77.5762H59.0265Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7993 76.9043L18.8301 99.2182C19.0911 100.823 19.3521 102.502 19.6504 104.218L47.5789 77.1282C45.6026 77.0536 43.6637 76.9789 41.8366 76.9043H41.7993Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5417 77.1289L19.6133 104.219C19.9116 105.824 20.2099 107.465 20.5455 109.107L53.2467 77.3528C51.3078 77.2782 49.3688 77.2035 47.5044 77.1289H47.5417Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0187 156.683L59.3242 187.43C60.8157 187.989 62.2699 188.512 63.7242 188.959L92.0628 161.459",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4029 149.294C87.4029 149.294 87.2537 148.996 87.1791 148.847L51.3457 183.623C52.5762 184.37 53.8813 185.041 55.2236 185.676L89.5656 152.317C88.5588 150.899 87.813 149.817 87.4402 149.257L87.4029 149.294Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M91.019 156.682L91.9885 155.749C91.0563 154.518 90.2359 153.361 89.5275 152.354L55.1855 185.712C56.5279 186.347 57.9448 186.944 59.3245 187.466L91.019 156.719",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8159 165.563L68.3857 190.265C70.1755 190.713 71.8162 191.012 73.3823 191.236L95.1583 170.079",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1003 161.459L63.7617 188.96C64.6193 189.221 65.4397 189.482 66.26 189.706C67.0057 189.93 67.7142 190.079 68.4227 190.266L93.2563 166.161",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3888 180.488L85.5381 191.011C86.433 190.899 87.3279 190.75 88.2974 190.6C89.8635 190.377 91.3177 190.115 92.7346 189.817L97.4328 185.265",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1883 171.011L73.3818 191.198C75.3208 191.459 77.1479 191.571 79.0123 191.534M79.0123 191.534L95.3443 175.675M79.0123 191.534C81.0631 191.496 83.1512 191.31 85.5376 190.974L97.4697 179.369",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M84.047 128.696L41.1289 170.339C41.7628 171.981 42.3221 173.399 42.7696 174.555L85.5012 133.099",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4333 137.95L44.8203 178.324C45.6406 179.332 46.6474 180.339 47.8033 181.235L87.8876 142.316",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5002 133.062L42.7686 174.556C42.9177 174.929 43.0669 175.302 43.1787 175.601C43.5516 176.571 44.1482 177.466 44.8567 178.362L86.4697 137.988",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M81.623 119.405L37.9219 161.832C38.4812 163.287 39.0032 164.705 39.5252 166.085M39.5252 166.085L83.2637 123.622M39.5252 166.085C40.0846 167.578 40.6439 169.033 41.1286 170.339L84.0467 128.697",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M87.887 142.354L47.8027 181.272C48.8468 182.13 50.04 182.914 51.3078 183.66L87.1412 148.883C86.0599 146.943 87.0666 146.122 89.9005 145.488",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M205.828 107.465C213.695 107.614 259.112 109.256 268.396 111.383C277.681 113.51 280.44 129.406 281.149 141.048C281.857 152.69 279.881 165.675 277.718 170.302C275.555 174.929 271.417 175.34 266.084 176.31C260.752 177.243 258.664 177.877 260.529 181.161C262.393 184.444 277.942 210.191 281.298 213.213C284.616 216.236 283.759 220.639 281.298 224.557C278.837 228.512 272.572 230.826 264.705 232.206C256.837 233.587 252.586 233.923 244.308 231.199C235.993 228.475 235.285 218.512 232.749 211.087C230.214 203.661 223.241 179.556 222.085 177.466C220.929 175.377 219.773 173.549 217.909 169.257C216.044 164.966 204.187 123.212 202.136 115.786C200.123 108.361 201.875 107.39 205.828 107.428V107.465Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M167.906 82.166V115.488C167.906 131.495 170.591 167.765 174.319 196.273C178.048 224.818 186.326 268.252 187.631 275.192C188.973 282.133 187.631 291.722 180.435 288.775C173.238 285.827 67.4902 245.304 67.4902 245.304",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9922 236.646L188.041 281.088",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 275.23L61.4873 228.55",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M183.157 72.3896V118.958C183.157 139.107 183.493 179.668 192.591 213.96C201.726 248.251 214.292 269.632 221.191 281.125C228.126 292.618 241.624 311.163 247.59 313.7C253.556 316.201 386.226 365.269 386.226 365.269",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M193.523 102.577C193.523 102.577 200.123 162.616 208.625 185.75C217.127 208.885 231.594 230.901 237.225 243.513C242.892 256.088 247.292 274.67 249.791 284.708C252.289 294.783 256.39 304.857 265.489 309.895C274.587 314.932 387.792 356.463 387.792 356.463",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M198.557 89.3672C198.557 89.3672 199.489 118.622 208.289 156.383C217.089 194.145 223.689 204.519 232.19 216.161C240.692 227.803 247.292 247.841 250.722 261.124C254.19 274.371 254.488 286.311 262.356 296.386C270.224 306.461 284.989 311.499 295.989 315.566C306.989 319.67 393.758 352.693 393.758 352.693",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M194.567 111.383C194.567 111.383 201.988 181.533 204.225 200.116",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5285 245.34C64.732 242.84 45.8644 179.518 32.5154 148.361C19.1664 117.203 16.0343 82.7251 18.0478 67.3144C18.5097 63.7214 19.6417 60.2343 21.1053 57",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5723 268.476C58.5792 254.296 50.9352 236.012 40.6438 206.31C30.3897 176.608 24.3118 158.809 15.3255 142.764C6.33918 126.719 4.40022 92.987 3.72904 72.6134C3.54068 66.8957 4.92352 61.6247 7.01049 57",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M66.26 267.318L63.7617 268.997",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0973 268.961C69.094 262.431 63.7619 250.379 59.5111 237.505C55.2603 224.669 45.7146 196.534 39.5622 181.161C33.4097 165.787 20.9929 137.653 17.3014 119.667C13.61 101.719 9.28459 79.8155 10.9252 65.7108C11.2624 62.745 12.2128 59.8007 13.5036 57",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M167.906 82.166V115.488C167.906 131.495 170.591 167.765 174.319 196.273C178.048 224.818 186.326 268.252 187.631 275.192C188.973 282.133 187.631 291.722 180.435 288.775C173.238 285.827 67.4902 245.304 67.4902 245.304",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9922 236.646L188.041 281.088",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 275.23L61.4873 228.55",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M183.157 72.3896V118.958C183.157 139.107 183.493 179.668 192.591 213.96C201.726 248.251 214.292 269.632 221.191 281.125C228.126 292.618 241.624 311.163 247.59 313.7C253.556 316.201 386.226 365.269 386.226 365.269",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M193.523 102.577C193.523 102.577 200.123 162.616 208.625 185.75C217.127 208.885 231.594 230.901 237.225 243.513C242.892 256.088 247.292 274.67 249.791 284.708C252.289 294.783 256.39 304.857 265.489 309.895C274.587 314.932 387.792 356.463 387.792 356.463",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M198.557 89.3672C198.557 89.3672 199.489 118.622 208.289 156.383C217.089 194.145 223.689 204.519 232.19 216.161C240.692 227.803 247.292 247.841 250.722 261.124C254.19 274.371 254.488 286.311 262.356 296.386C270.224 306.461 284.989 311.499 295.989 315.566C306.989 319.67 393.758 352.693 393.758 352.693",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M194.567 111.383C194.567 111.383 201.988 181.533 204.225 200.116",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5285 245.34C64.732 242.84 45.8644 179.518 32.5154 148.361C19.1664 117.203 16.0343 82.7251 18.0478 67.3144C18.5097 63.7214 19.6417 60.2343 21.1053 57",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5713 268.476C58.5782 254.296 50.9342 236.013 40.6428 206.31C30.3887 176.608 24.3109 158.809 15.3245 142.764C6.3382 126.719 4.39924 92.9872 3.72807 72.6137C3.54 66.9051 4.91812 61.6418 6.99951 57.0225",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M66.26 267.318L63.7617 268.997",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0973 268.961C69.094 262.431 63.7619 250.379 59.5111 237.505C55.2603 224.669 45.7146 196.534 39.5622 181.161C33.4097 165.787 20.9929 137.653 17.3014 119.667C13.61 101.719 9.28459 79.8155 10.9252 65.7108C11.2624 62.745 12.2128 59.8007 13.5036 57",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M251.915 114.891C251.915 114.891 259.335 121.197 260.491 132.988C261.647 144.779 261.945 156.384 261.573 164.033C261.2 171.683 260.044 173.063 260.044 173.063",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M189.533 37.5754C189.533 70.9343 225.889 69.4044 225.889 69.4044C225.889 69.4044 324.216 68.1357 338.572 68.1357C352.928 68.1357 358.111 71.7552 358.111 71.7552C390.588 90.8974 456.587 89.3302 456.587 89.3302C504.278 89.3302 501.929 49.8144 501.929 49.8144C501.929 18.9556 469.079 9.739 469.079 9.739C455.394 3.35827 403.229 2.31348 403.229 2.31348C342.785 2.31348 268.62 9.32854 215.672 15.5227C215.672 15.5227 189.533 18.0228 189.533 37.5754Z",
    fill: "#686D71",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M335.999 4.58994L269.776 68.8823C271.753 68.8823 273.803 68.845 275.817 68.8077L342.338 4.2168C340.213 4.32874 338.087 4.478 335.962 4.58994H335.999Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M315.565 5.93333L250.498 69.1063C252.623 69.1063 254.823 69.0689 257.098 69.0316L322.612 5.44824C320.263 5.5975 317.914 5.78407 315.565 5.93333Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M329.026 5.03761L263.139 68.9941C265.301 68.9941 267.501 68.9568 269.739 68.9195L335.999 4.58984C333.687 4.7391 331.375 4.88836 329.026 5.03761Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M322.613 5.44757L257.099 69.0309C259.075 69.0309 261.088 68.9936 263.139 68.9563L329.027 5.03711C326.901 5.18637 324.738 5.33562 322.613 5.48488V5.44757Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M309.115 6.4177L244.458 69.1802C246.36 69.1802 248.411 69.1428 250.499 69.1055L315.566 5.93262C313.403 6.08187 311.24 6.23113 309.115 6.4177Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M302.03 6.97768L237.858 69.2924C239.872 69.2924 242.072 69.2551 244.458 69.2177L309.115 6.41797C306.729 6.60454 304.38 6.79111 302.03 6.97768Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M375.337 2.79888L307.697 68.4718C309.785 68.4718 311.799 68.4345 313.738 68.3972L381.49 2.6123C379.439 2.64962 377.388 2.72425 375.337 2.79888Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M295.505 7.49994L231.78 69.3295C233.496 69.3295 235.509 69.2922 237.821 69.2549L302.03 6.97754C299.868 7.16411 297.705 7.31337 295.542 7.49994H295.505Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M342.338 4.21689L275.779 68.8077C277.979 68.8077 280.179 68.7704 282.379 68.7331L349.236 3.84375C346.924 3.95569 344.65 4.06764 342.338 4.21689Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M381.49 2.61215L313.738 68.3597C316.05 68.3597 318.25 68.3224 320.338 68.2851L388.164 2.46289C385.964 2.5002 383.727 2.53752 381.49 2.61215Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M362.362 3.24655L295.058 68.5837C297.108 68.5837 299.122 68.5464 301.098 68.5091L368.589 2.98535C366.538 3.05998 364.45 3.13461 362.362 3.24655Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M355.538 3.54461L288.457 68.6579C290.694 68.6579 292.894 68.6205 295.057 68.5832L362.361 3.24609C360.087 3.32072 357.812 3.43266 355.538 3.54461Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M349.237 3.84344L282.38 68.7328C284.393 68.7328 286.407 68.6955 288.42 68.6582L355.538 3.54492C353.45 3.65686 351.362 3.76881 349.237 3.88075V3.84344Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M189.533 37.575L211.496 16.2686C204.113 17.9104 189.533 22.9851 189.533 37.575Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M225.964 14.3664L191.025 48.285C191.473 49.7776 192.032 51.1955 192.666 52.4642L232.676 13.6201C230.401 13.8813 228.127 14.1052 225.927 14.3664H225.964Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M232.712 13.6197L192.702 52.4638C193.411 53.9191 194.231 55.2251 195.126 56.4564L240.095 12.7988C237.596 13.06 235.173 13.3212 232.749 13.5824L232.712 13.6197Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M218.543 15.2244L189.869 43.0608C190.13 44.9265 190.503 46.6803 190.988 48.2848L225.926 14.3662C223.391 14.6647 220.967 14.9259 218.506 15.2244H218.543Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M288.345 8.09703L225.18 69.4042C225.627 69.4042 225.888 69.4042 225.888 69.4042C225.888 69.4042 228.088 69.4042 231.78 69.3296L295.504 7.5C293.118 7.68657 290.731 7.91046 288.345 8.09703Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M388.164 2.46232L320.338 68.2845C322.463 68.2845 324.514 68.2472 326.378 68.2472L394.205 2.3877C392.191 2.3877 390.178 2.42501 388.164 2.46232Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M240.058 12.7988L195.089 56.4564C195.946 57.6132 196.841 58.658 197.811 59.5908L246.77 12.0898C244.495 12.3137 242.295 12.5749 240.058 12.7988Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M215.672 15.5226C215.672 15.5226 213.994 15.6718 211.496 16.2315L189.533 37.5379C189.533 39.4783 189.645 41.2693 189.906 42.9858L218.543 15.1494C217.574 15.2614 216.604 15.3733 215.672 15.4852V15.5226Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M274.586 9.32888L214.105 68.0614C216.082 68.5465 217.946 68.845 219.587 69.0689L281.783 8.65723C279.359 8.88111 276.972 9.105 274.586 9.32888Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M281.783 8.65737L219.587 69.0317C222.16 69.3676 224.173 69.4049 225.18 69.4049L288.345 8.09766C286.145 8.28423 283.945 8.4708 281.783 8.65737Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M267.987 9.96247L209.52 66.7173C211.086 67.2771 212.614 67.7248 214.106 68.0607L274.587 9.32812C272.387 9.55201 270.187 9.73858 267.987 9.96247Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M246.769 12.09L197.811 59.591C198.929 60.6731 200.085 61.6433 201.316 62.5015L254.04 11.3438C251.579 11.6049 249.156 11.8288 246.732 12.09H246.769Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M254.078 11.3435L201.354 62.5013C202.547 63.3595 203.777 64.0685 205.045 64.7401L260.753 10.6719C258.515 10.8958 256.316 11.1196 254.078 11.3435Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M260.716 10.6719L205.008 64.7401C206.499 65.5237 207.991 66.1581 209.52 66.7178L267.987 9.96289C265.563 10.1868 263.139 10.4107 260.716 10.6719Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M368.588 2.9856L301.098 68.5093C303.335 68.5093 305.535 68.472 307.698 68.4347L375.337 2.76172C373.1 2.83635 370.863 2.91098 368.588 2.9856Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M488.133 20.374L418.815 87.6888C420.866 87.8754 422.842 88.062 424.781 88.2112L491.452 23.5084C490.37 22.389 489.289 21.3442 488.17 20.374H488.133Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M472.733 11.082L396.965 84.6283C398.829 84.9641 400.656 85.3 402.521 85.5985L477.171 13.097C475.493 12.2388 474.001 11.5671 472.733 11.082Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M494.136 26.6797L430.337 88.6212C432.5 88.7705 434.55 88.8824 436.489 88.9571L496.746 30.4857C495.963 29.1424 495.068 27.8737 494.136 26.6797Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M484.851 17.7617L413.445 87.0542C415.272 87.2781 417.062 87.4646 418.815 87.6512L488.17 20.3737C487.088 19.4409 485.97 18.5826 484.888 17.7617H484.851Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M496.746 30.4856L436.489 88.9569C438.503 89.0688 440.442 89.1435 442.232 89.1808L498.722 34.3289C498.126 32.9856 497.455 31.6796 496.746 30.4482V30.4856Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M477.171 13.0977L402.483 85.5991C404.236 85.8603 405.951 86.1215 407.666 86.3827L480.974 15.2246C479.632 14.441 478.364 13.732 477.171 13.135V13.0977Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M480.974 15.1865L407.666 86.3447C409.605 86.6059 411.544 86.8671 413.446 87.091L484.851 17.7612C483.546 16.8283 482.241 15.9328 480.974 15.1865Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M394.205 2.3879L326.342 68.2475C328.84 68.2475 331.04 68.2101 332.942 68.1728L400.805 2.35059C398.643 2.35059 396.443 2.35059 394.243 2.3879H394.205Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M499.543 64.1436L476.686 86.3082C490.37 81.6066 496.672 72.2407 499.543 64.1436Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M498.722 34.3662L442.231 89.2181C444.618 89.2927 446.743 89.33 448.608 89.3673L500.438 39.0678C499.953 37.426 499.393 35.8588 498.722 34.3662Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M499.543 64.1431C500.624 61.0834 501.221 58.2102 501.556 55.8594L467.96 88.472C471.167 87.9496 474.075 87.2406 476.685 86.3077L499.543 64.1431Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M501.892 49.8522C501.892 49.8522 501.892 49.7775 501.892 49.7402L461.211 89.2186C463.597 89.0694 465.835 88.8455 467.923 88.4724L501.519 55.8598C502.041 52.2403 501.892 49.8149 501.892 49.8149V49.8522Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M500.437 39.0305L448.607 89.33C451.18 89.3673 453.194 89.3673 454.536 89.33L501.444 43.8067C501.183 42.1276 500.847 40.523 500.4 38.9932L500.437 39.0305Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M501.444 43.8438L454.536 89.4044C455.841 89.4044 456.587 89.4044 456.587 89.4044C458.19 89.4044 459.756 89.3671 461.248 89.2551L501.929 49.7767C501.929 47.7244 501.78 45.7468 501.481 43.8811L501.444 43.8438Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M491.452 23.5078L424.781 88.2106C426.683 88.3599 428.547 88.5091 430.337 88.6211L494.136 26.6795C493.279 25.5601 492.384 24.5153 491.452 23.5078Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M418.666 2.91016L350.393 69.1802C352.593 69.6279 354.27 70.113 355.501 70.5608L424.856 3.24598C422.693 3.13404 420.643 3.0221 418.666 2.91016Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M412.961 2.64941L345.172 68.4716C347.185 68.6582 348.901 68.9194 350.392 69.1806L418.666 2.91061C416.615 2.79867 414.713 2.72404 412.961 2.64941Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M424.856 3.24609L355.501 70.5609C357.291 71.2325 358.111 71.7549 358.111 71.7549C358.559 72.0161 359.006 72.24 359.453 72.5012L430.449 3.61924C428.548 3.46998 426.683 3.35804 424.856 3.24609Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M406.697 2.42578L338.945 68.1734C341.257 68.1734 343.345 68.2853 345.172 68.4719L412.961 2.64967C410.463 2.53772 408.3 2.4631 406.66 2.42578H406.697Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M403.229 2.31348C402.446 2.31348 401.625 2.31348 400.805 2.31348L332.941 68.173C335.365 68.173 337.304 68.173 338.572 68.173C338.721 68.173 338.833 68.173 338.945 68.173L406.696 2.42542C404.496 2.35079 403.229 2.35079 403.229 2.35079V2.31348Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M430.449 3.61914L359.453 72.5385C360.833 73.322 362.25 74.031 363.704 74.74L436.489 4.10423C434.476 3.91765 432.425 3.7684 430.449 3.61914Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M458.601 6.86544L381.938 81.2699C383.504 81.6804 385.07 82.0909 386.673 82.5013L463.486 7.91024C461.994 7.53709 460.353 7.16395 458.601 6.82812V6.86544Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M453.046 5.93262L376.941 79.8147C378.582 80.3371 380.26 80.8222 381.975 81.27L458.601 6.86547C456.849 6.52964 454.984 6.23113 453.046 5.93262Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M469.041 9.77585C468.855 9.70122 468.594 9.58928 468.37 9.51465L391.968 83.6953C393.608 84.0311 395.286 84.3669 396.927 84.6654L472.733 11.0818C470.496 10.1863 469.079 9.77585 469.079 9.77585H469.041Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M463.485 7.91016L386.673 82.4639C388.425 82.8744 390.178 83.2848 391.968 83.658L468.407 9.47735C467.065 8.91764 465.387 8.39524 463.485 7.91016Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M441.934 4.58984L367.806 76.5316C369.334 77.1659 370.901 77.7256 372.504 78.3227L447.788 5.22418C445.886 5.0003 443.91 4.77641 441.934 4.58984Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M436.49 4.06738L363.704 74.7031C365.046 75.3375 366.389 75.9345 367.806 76.5315L441.934 4.58978C440.144 4.40321 438.317 4.25395 436.49 4.1047V4.06738Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M447.788 5.22363L372.467 78.3221C373.921 78.8445 375.413 79.3296 376.904 79.8147L453.045 5.9326C451.33 5.6714 449.578 5.44752 447.788 5.22363Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M332.121 71.0088C332.121 71.0088 337.602 74.3671 337.602 84.7404C337.602 95.1137 334.843 100.002 334.843 100.002",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M320.562 100.935C320.562 100.935 315.715 95.039 315.715 86.0463C315.715 77.0536 320.786 68.3594 325.596 68.3594C330.406 68.3594 340.623 68.8818 346.887 68.8818C353.152 68.8818 365.084 75.8222 367.47 83.285C369.894 90.7479 365.196 98.6958 365.196 98.6958",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M296.922 110.376C300.054 113.174 301.247 114.555 302.925 116.719C309.712 125.637 322.278 146.608 334.284 175.564C334.284 175.564 346.328 149.369 350.057 141.944C353.786 134.518 354.755 132.988 360.982 131.682C360.982 131.682 372.094 129.593 377.575 129.257C390.253 128.473 402.782 128.212 408.002 128.175H410.5L410.985 127.092C410.985 127.092 411.209 123.436 410.761 121.122C410.5 119.704 407.853 111.57 405.988 104.331C404.161 97.0919 388.127 47.2401 387.494 44.3669C386.673 40.6728 386.673 39.5907 382.273 38.0981C377.873 36.6429 335.925 48.8073 327.498 50.4491C319.071 52.091 312.023 63.5837 312.023 63.5837L296.996 110.413",
    fill: "#686D71"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M296.922 110.376C300.054 113.174 301.247 114.555 302.925 116.719C309.712 125.637 322.277 146.608 334.284 175.564C334.284 175.564 346.328 149.369 350.057 141.944C353.786 134.518 354.755 132.988 360.982 131.682C360.982 131.682 372.094 129.593 377.575 129.257C390.253 128.473 402.782 128.212 408.002 128.175H410.5L410.985 127.092C410.985 127.092 411.209 123.436 410.761 121.122C410.5 119.704 407.853 111.57 405.988 104.331C404.161 97.0919 388.127 47.2401 387.494 44.3669C386.673 40.6728 386.673 39.5907 382.273 38.0981C377.873 36.6429 335.925 48.8073 327.498 50.4491C319.071 52.091 312.023 63.5837 312.023 63.5837L296.996 110.413",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M409.344 126.533C405.876 121.756 401.924 117.279 397.561 113.435C382.758 100.599 372.84 98.8828 360.982 98.8828C349.125 98.8828 317.84 101.532 311.054 101.532C304.268 101.532 296.512 109.965 296.512 109.965",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M320.487 100.636C320.487 100.636 315.603 94.7031 315.603 85.6358C315.603 76.5684 320.711 67.8369 325.558 67.8369H349.311C355.612 67.8369 365.307 75.3371 367.731 82.8745C370.154 90.3747 365.456 98.3972 365.456 98.3972",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M332.121 71.0088C332.121 71.0088 337.64 74.4044 337.64 84.815C337.64 95.2257 334.88 100.151 334.88 100.151",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M323.955 102.801C323.955 102.801 341.555 120.04 346.663 130.451C347.633 132.466 349.05 135.376 350.69 138.884",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M332.121 101.121C332.121 101.121 346.141 112.465 350.019 117.315C353.897 122.166 355.351 126.756 355.351 126.756",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M370.154 101.121C370.154 101.121 376.68 108.36 380.222 116.121C383.727 123.883 381.564 129.219 381.564 129.219",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M399.611 83.4717L325.67 155.227",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M324.328 150.712L398.232 78.9941",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M401.029 87.9492L327.236 159.555",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M317.393 139.966L394.019 65.5986",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M391.856 61.8301L315.268 136.16",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M322.091 147.055L396.815 74.5166",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M395.398 70.0391L319.854 143.399",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M313.142 132.391L390.476 57.3145",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M348.117 145.152L329.101 163.586",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M401.7 93.1357L363.182 130.525",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M343.605 155.339L331.562 167.056",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M403.788 96.9424L370.154 129.555",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M401.588 128.249L409.903 120.189",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M404.608 101.979L376.456 129.293",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M338.684 165.974L333.314 171.198",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M406.399 106.084L382.87 128.92",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M396.069 127.763L409.008 115.188",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M407.703 110.674L389.171 128.659",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M410.984 124.965L407.703 128.137",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M309.227 72.0162L332.792 49.1426",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M311.948 63.5465L324.514 51.3447",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M340.959 47.0527L306.505 80.4862",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M380.371 37.9482L301.321 114.704",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M303.895 118.025L385.032 39.292",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M386.45 43.7695L306.318 121.495",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M365.419 40.8213L299.383 104.927",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M298.376 111.719L373.212 39.0684",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M349.199 44.8887L303.82 88.9567",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M301.098 97.4278L357.365 42.7998",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M310.941 128.697L389.245 52.6875",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M388.425 47.6875L308.667 125.077",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlanderSafetyAirbags1);
export default __webpack_public_path__ + "static/media/outlander-safety-airbags-1.86350cc6ebccd81d37d3d7cd1cd543b2.svg";
export { ForwardRef as ReactComponent };